import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { HttpClientModule } from '@angular/common/http';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ResultComponent } from './result/result.component';
import { SearchResultsLocationComponent } from './search-results-location/search-results-location.component';
import { SearchByLocationComponent } from './search-by-location/search-by-location.component';
import { SearchLocationNoResultsComponent } from './search-location-no-results/search-location-no-results.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NavbarComponent } from './navbar/navbar.component';
import { FileAnIssueComponent } from './file-an-issue/file-an-issue.component';
import { IssueFiledComponent } from './issue-filed/issue-filed.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SearchResultsLocationComponent,
    SearchByLocationComponent,
    SearchLocationNoResultsComponent,
    ResultComponent,
    HomeComponent,
    FooterComponent,
    HeaderComponent,
    FileAnIssueComponent,
    IssueFiledComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    HttpClientModule,
    GooglePlaceModule,
    BrowserAnimationsModule,
    TypeaheadModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
